import { Box, Typography } from "@mui/material";
import { CalendarToday as CalendarIcon } from "@mui/icons-material";
import React from "react";
import { formatDate } from "../../utils/absenceUtils";

interface DateRangeDisplayProps {
  startDate: string;
  endDate: string;
  /** Number of days to display next to the date range (e.g. the days actually deducted from balance). */
  days?: number;
  showIcon?: boolean;
  variant?: "inline" | "stacked";
}

export const DateRangeDisplay: React.FC<DateRangeDisplayProps> = ({
  startDate,
  endDate,
  days,
  showIcon = true,
  variant = "inline",
}) => {
  const start = formatDate(startDate);
  const end = formatDate(endDate);
  const isSameDay = start === end;

  if (variant === "stacked") {
    return (
      <Box>
        <Box display="flex" alignItems="center" gap={0.5} mb={0.5}>
          {showIcon && <CalendarIcon sx={{ fontSize: 16, color: "text.secondary" }} />}
          <Typography variant="body2" fontWeight={500}>
            {isSameDay ? start : `${start} - ${end}`}
          </Typography>
        </Box>
        {!!days && days > 0 && (
          <Typography variant="caption" color="text.secondary">
            {days} {days === 1 ? "day" : "days"}
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <Box display="flex" alignItems="center" gap={0.5} flexWrap="wrap">
      {showIcon && <CalendarIcon sx={{ fontSize: 16, color: "text.secondary" }} />}
      <Typography variant="body2">
        {isSameDay ? start : `${start} - ${end}`}
      </Typography>
      {!!days && days > 0 && (
        <Typography variant="caption" color="text.secondary">
          ({days} {days === 1 ? "day" : "days"})
        </Typography>
      )}
    </Box>
  );
};







